<template>
  <div style="display: flex; flex-direction: column; color: white">
    <div>
      {{ date }} <br />
      ({{ day }})
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      day: null,
      date: null
    }
  },
  mounted() {
    this.day = this.params?.value.split('-')[1]
    this.date = this.params?.value.split('-')[0]
    this.day = this.day.charAt(0).toUpperCase() + this.day.slice(1)
  },

  methods: {}
}
</script>
